const actionTypes = {
  SET_DATA: 'SET_DATA',
  'RESET_DATA': 'RESET_DATA'
}

export default actionTypes
